import {Link} from 'gatsby';
import React from 'react';
import {buildImageObj, imageUrlFor} from './sanity/image-url';
import Icon from './icon';

function PeopleTeaser(props) {
  const isSpecialist = props.categories.find(category => category.categoryTitle === 'Specialists');
  return (
    <Link to={`/people/${props.slug.current}`} className="tile tile--rounded tile__person">
      <figure className="tile__media">
        {props.previewImage && props.previewImage.asset && (
          <img
            className="tile__img lazy" 
            src={imageUrlFor(buildImageObj(props.previewImage))
              .width(576)
              .height(334)
            }
            alt={props.previewImage.alt}
          />
        )}
        <div className='tile__hover'>
          {isSpecialist && (
            <span>Socials here</span>
          )}
          {!isSpecialist && (
            <>
              <span className='title'>Learn more</span>
              <span className='corner'><Icon symbol="page-fold" /></span>
            </>
          )}
        </div>
      </figure>
      <div className="tile__body">
        <strong className="tile__title">{ props.name }</strong>
        <div className="tile__subtitle">{ props.jobTitle }</div>
      </div>
    </Link>
  );
}

export default PeopleTeaser;
